export default {
    newProperty: 'New property',
    saveOrder: 'Save order',
    newGroup: 'New Group',

    tabs: {
        schema: 'Schema',
        matchRules: 'Match rules',
        groups: 'Groups',
        popup: 'Popup',
    },

    creation: {
        form: {
            key: {
                label: 'Key',
                placeholder: 'Insert key',
            },
            name: {
                label: 'Name',
                placeholder: 'Insert name',
            },
            type: {
                label: 'Type',
                placeholder: 'Insert type',
            },
            fields: {
                label: 'Fields',
                placeholder: 'Select fields',
            },
            matchFrom: {
                label: 'Match from',
                placeholder: 'Select match',
            },
            matchTo: {
                label: 'Match to',
                placeholder: 'Select match',
            },
            autoMatch: {
                label: 'Auto match',
            },
            locked: {
                label: 'Locked',
            },
            against: {
                label: 'Match entity',
                placeholder: 'Select entity',
            },
        },
    },

    matchs: {
        headers: {
            type: 'Type',
            matchTo: 'Match To',
            fields: 'Fields',
            entity: 'From Entity',
            matchToFields: 'Fields',
            matchFromFields: 'From fields',
            matchFrom: 'Match From',
            autoMatch: 'Auto Match',
            locked: 'Locked',
        },
    },

    modals: {
        saveOrder: {
            title: 'Do you want save this order?',
        },
        saveOrderSuccess: {
            title: 'Great!',
            text: 'Order save successfully.',
        },
    },

    groups: {
        cancel: 'Cancel',
        name: 'Name',
        icon: 'Icon',
        create: 'Create',
        delete: 'Delete',
        deleting: 'Deleting ...',
        creating: 'Creating ...',
        deleteAdvice: 'Do you really want to delete "{groupName}" group?',
        transferAdvice: 'To continue you must select in which group all the "{groupName}" fields will be transferred:',
        selectTransferGroup: 'Select a group',
    },

    popup: {
        properties: {
            all: 'All Properties',
            current: 'Popup Properties',
        },
        reset: 'Reset',
        save: 'Save',
    },
}
